// @ts-nocheck

import { createSelector } from 'reselect';

import { type SelectorMaker } from '../../../../types/selectors';
import { selectBoomUserProgressEntity } from '../../selectors/user/userPrimary.selector';
import { type BoomStepStatus } from '../../types/steps';

type SelectBoomStepItemPropsType = {
  status: BoomStepStatus;
};

const makeSelectBoomStepItemPropsSelector: SelectorMaker<SelectBoomStepItemPropsType> = () => {
  return createSelector([selectBoomUserProgressEntity], (progress) => ({
    status: progress?.status,
  }));
};

export default makeSelectBoomStepItemPropsSelector;
